// extracted by mini-css-extract-plugin
export default {"alertContainer":"draft-alert-modal_alertContainer__kH+O0"};